import { users as usersServices } from '@coligo-org/fe-common/services';
import { usersTypes } from '../../reducers/types';
import logger from '../../../common/services/logService';
import { ErrorsActions } from '../error';

export const updateUserStart = () => ({
  type: usersTypes.UPDATE_USER_START,
});

export const updateUserEnd = () => ({
  type: usersTypes.UPDATE_USER_END,
});

export default ({ userId, callback }) =>
  async dispatch => {
    try {
      dispatch(updateUserStart());
      await usersServices.deactivateUser({ userId });
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(updateUserEnd());
    }
  };
